<template>
  <div>
    <div v-if="!filmtype" class="text-center">
      <b-spinner />
    </div>
    <div v-if="filmtype">
      <app-header
        :title="filmtype.name"
        :subtitle="'Film Type #' + filmtype.id"
      >
        <b-button
          v-router-link="{
            name: 'filmtype-editor',
            query: { id: filmtype.id },
          }"
          variant="primary"
        >
          <i class="fa fa-pencil-square-o" style="font-size:20px" /> Edit Film
          Type
        </b-button>
        &nbsp;
        <b-button
          v-router-link="{
            name: 'filmtype-editor',
            query: { id: filmtype.id, duplicate: true },
          }"
          variant="secondary"
        >
          <i class="fa fa-plus-circle" /> Duplicate Film Type
        </b-button>
      </app-header>
      <b-container>
        <b-tabs>
          <b-tab title="Profile" fade show active class="mt-3">
            <b-row>
              <b-col md="4">
                <!--description-->
                <b-card no-body>
                  <b-card-header>
                    Description
                  </b-card-header>
                  <b-card-body>
                    {{ filmtype.description }}
                  </b-card-body>
                </b-card>

                <b-card no-body class="mt-3">
                  <b-card-header>
                    Categories
                  </b-card-header>
                  <b-card-body>
                    <div
                      v-for="category in filmtype.filmtypecategories"
                      :key="category.id"
                      v-router-link="{
                        name: 'filmtypecategory-editor',
                        query: { id: category.filmtypecategory_id },
                      }"
                    >
                      {{ category.name }}
                    </div>
                    <div v-if="!filmtype.filmtypecategories.length">
                      [No Category]
                    </div>
                  </b-card-body>
                </b-card>

                <!--Settings-->
                <b-card no-body class="mt-3">
                  <b-card-header>
                    Settings
                  </b-card-header>
                  <b-table-simple>
                    <b-tr>
                      <b-td>Cycles</b-td>
                      <b-td class="text-right">
                        {{ filmtype.cycles }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Alignment Cycles</b-td>
                      <b-td class="text-right">
                        {{ filmtype.alignment_cycles }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Depth</b-td>
                      <b-td class="text-right">
                        {{ filmtype.depth }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Height</b-td>
                      <b-td class="text-right"> {{ filmtype.height }} mm </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Width</b-td>
                      <b-td class="text-right"> {{ filmtype.width }} mm </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Pressure</b-td>
                      <b-td class="text-right">
                        {{ filmtype.pressure }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Speed</b-td>
                      <b-td class="text-right">
                        {{ filmtype.speed }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Teneth Pressure</b-td>
                      <b-td class="text-right">
                        {{ filmtype.teneth_pressure }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Teneth Speed</b-td>
                      <b-td class="text-right">
                        {{ filmtype.teneth_speed }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Teneth Mini Pressure</b-td>
                      <b-td class="text-right">
                        {{ filmtype.teneth_mini_pressure }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Teneth Mini Speed</b-td>
                      <b-td class="text-right">
                        {{ filmtype.teneth_mini_speed }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Mycut Pressure</b-td>
                      <b-td class="text-right">
                        {{ filmtype.mycut_pressure }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Mycut Speed</b-td>
                      <b-td class="text-right">
                        {{ filmtype.mycut_speed }}
                      </b-td>
                    </b-tr>

                    <b-tr>
                      <b-td>Hidden</b-td>
                      <b-td class="text-right">
                        {{ filmtype.hidden ? 'Hidden' : 'Not Hidden' }}
                      </b-td>
                    </b-tr>

                    <b-tr>
                      <td>Reversable</td>
                      <b-td class="text-right">
                        {{
                          filmtype.reversable ? 'Reversable' : 'Not Reversable'
                        }}
                      </b-td>
                    </b-tr>

                    <b-tr>
                      <b-td>Medium Tablet Cut Position</b-td>
                      <b-td class="text-right">
                        {{ filmtype.tablet_medium ? 'Yes' : 'No' }}
                      </b-td>
                    </b-tr>

                    <b-tr>
                      <b-td>Four Seasons Type</b-td>
                      <b-td class="text-right">
                        {{ filmtype.fsfilmtype_name || 'None' }}
                      </b-td>
                    </b-tr>

                    <b-tr>
                      <b-td>Created</b-td>
                      <b-td class="text-right">
                        {{ filmtype.created | moment('YYYY-MM-DD') }}
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Updated</b-td>
                      <b-td class="text-right">
                        {{ filmtype.updated | moment('YYYY-MM-DD') }}
                      </b-td>
                    </b-tr>
                  </b-table-simple>
                </b-card>
              </b-col>
              <b-col md="4">
                <!-- Country Restrictions -->
                <b-card no-body>
                  <b-card-header>
                    Country Availability
                  </b-card-header>
                  <b-card-body>
                    <search-input v-model="query" />
                    <div
                      v-for="country in displayCountries"
                      :key="country.id"
                      class="form-check"
                    >
                      <label class="form-check-label">
                        <input
                          v-model="country.allowed"
                          class="form-check-input"
                          type="checkbox"
                          @change="handleCountryChange(country)"
                        />
                        {{ country.name }}
                      </label>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col md="4">
                <!-- Device Availability -->
                <b-card no-body>
                  <b-card-header>
                    Device Availability
                  </b-card-header>
                  <b-card-body>
                    <div
                      v-for="category in categories"
                      :key="category.id"
                      class="form-check"
                    >
                      <label class="form-check-label">
                        <input
                          v-model="category.allowed"
                          class="form-check-input"
                          type="checkbox"
                          @change="handleCategoryChange(category)"
                        />
                        {{ category.name }}
                      </label>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-container>
    </div>
  </div>
</template>

<script>
import $api from '@/services/api';
import $search from '@/services/search';
import AppHeader from '@/components/AppHeader';
import SearchInput from '@/components/SearchInput';

export default {
  components: {
    AppHeader,
    SearchInput,
  },

  data: () => ({
    query: '',
    filmtype: null,
    countries: null,
    categories: null,
  }),

  computed: {
    displayCountries() {
      return $search(this.countries, this.query);
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    handleCountryChange(country) {
      $api.put(
        `/v1/internal/filmtypes/${this.$route.params.id}/countries/${country.id}`,
        {
          disallowed: !country.allowed,
        },
      );
    },

    handleCategoryChange(category) {
      $api.put(
        `/v1/internal/filmtypes/${this.$route.params.id}/devicecategories/${category.id}`,
        {
          disallowed: !category.allowed,
        },
      );
    },

    refreshData() {
      return Promise.all([
        $api.get(`/v1/internal/filmtypes/${this.$route.params.id}`),
        $api.get('/v1/internal/countries'),
        $api.get('/v1/internal/devicecategories'),
      ]).then((resps) => {
        [this.filmtype] = resps;

        const disallowedCountries = this.filmtype.countries
          .filter((country) => country.disallowed)
          .map((country) => country.country_code);

        this.countries = resps[1].map((country) => {
          country.allowed = !disallowedCountries.includes(country.id);
          return country;
        });

        const disallowedCategories = this.filmtype.devicecategories
          .filter((category) => category.disallowed)
          .map((category) => category.devicecategory_id);

        this.categories = resps[2].map((category) => {
          category.allowed = !disallowedCategories.includes(category.id);
          return category;
        });
      });
    },

    searchItem(query) {
      this.countries = this.countries.filter((countries) =>
        countries.name.toLowerCase().includes(query.toLowerCase()),
      );
      if (!query) {
        this.refreshData();
      }
    },
  },
};
</script>
